import type { OutOfPageAdType } from '@/modules/adv'

export function isAdTypeHasPreroll(type: OutOfPageAdType): boolean {
    return ['interstitial', 'rewarded', 'interstitial_preroll'].includes(type)
}
